import { round } from "lodash";
import { v4 as uuidv4 } from "uuid";

import { FoodItemFragment } from "@/gql/graphql";

type EdamamHint = {
  food?: {
    category?: string | null;
    label?: string | null;
    nutrients?: {
      CHOCDF?: number | null;
      ENERC_KCAL?: number | null;
      FAT?: number | null;
      PROCNT?: number | null;
    } | null;
  } | null;
};

type EdamamResponse = {
  hints?: EdamamHint[];
};

export async function fetchEdamamFoods(
  searchString: string
): Promise<FoodItemFragment[]> {
  const appId = import.meta.env.VITE_EDAMAM_APP_ID?.toString();
  const appKey = import.meta.env.VITE_EDAMAM_APP_KEYS?.toString();

  if (!appId || !appKey || searchString.trim() === "") return [];

  try {
    const params = new URLSearchParams({
      app_id: appId,
      app_key: appKey,
      ingr: searchString,
      "nutrition-type": "cooking",
    });

    const response = await fetch(
      `https://api.edamam.com/api/food-database/v2/parser?${params.toString()}`
    );

    if (!response.ok) return [];

    const data = (await response.json()) as EdamamResponse;

    return (data.hints ?? []).map((hint) => {
      const tempFoodId = uuidv4();
      const tempFoodPortionFoodId = -1;

      return {
        __typename: "Food",
        id: tempFoodId,
        source: "edamam",
        sourceId: uuidv4(),
        category: hint.food?.category ?? "edamam food",
        name: hint.food?.label ?? "",
        epWeightGrams: 100,
        energyKcal: round(hint.food?.nutrients?.ENERC_KCAL ?? 0, 2),
        carbohydrateGrams: round(hint.food?.nutrients?.CHOCDF ?? 0, 2),
        proteinGrams: round(hint.food?.nutrients?.PROCNT ?? 0, 2),
        fatGrams: round(hint.food?.nutrients?.FAT ?? 0, 2),
        allergies: [],
        portions: [
          {
            __typename: "FoodPortion",
            id: `${tempFoodId}-portion`,
            foodId: tempFoodPortionFoodId,
            amount: 100,
            unit: "grams",
            unitWithModifier: "grams",
            weightGrams: 100,
          },
        ],
      };
    });
  } catch (error) {
    console.error("Unable to fetch Edamam foods", error);
    return [];
  }
}
